import { Box, styled, TextField, Select } from "@mui/material";

export const StyledOrdersContainer = styled(Box)(({ theme, background }) => ({
    background: background
        ? theme.palette.custom.orderCards
        : theme.palette.custom.white,
    paddingTop: '20px'
}));
export const StyledTableLayout = styled(Box)(({ theme }) => ({
    background: theme.palette.custom.white,
    padding: theme.padding.size.large,
    boxShadow: " 0px 0px 12px rgba(0, 0, 0, 0.08)",
    borderRadius: theme.borderRadius.radius.regular,
}));
export const StyledBoxStyle = styled(Box)(({ theme }) => ({
    paddingTop: "20px",
    width: "100%",
    display: "flex",
    gap: 20,
    flexWrap: "wrap",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "stretch",
    },
}));
export const StyledCustomerSearch = styled(TextField)(({ theme }) => ({
    height: "36px",
    flex: 1,
    minWidth: 0,
    width: "100%",
    "& .MuiInputBase-input": {
        fontSize: theme.typography.small.fontSize,
    },
    "& .MuiOutlinedInput-root": {
        height: "36px",
        paddingLeft: "20px",
        borderRadius: theme.borderRadius.radius.medium,
        background: theme.palette.custom.searchBg,
        color: theme.palette.custom.orderButtonColor,
    },
    "& .MuiOutlinedInput-input": {
        padding: "0px",
        background: "transparent",
    },
    "& fieldset": { border: "none" },
}));
export const StyledStatusFilter = styled(Select)(({ theme }) => ({
    height: "36px",
    minWidth: "160px",
    flexShrink: 0,
    fontSize: theme.typography.small.fontSize,
    borderRadius: theme.borderRadius.radius.medium,
    background: theme.palette.custom.searchBg,
    color: theme.palette.custom.orderButtonColor,
    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
    "& .MuiSelect-select": {
        padding: "0px 32px 0px 20px",
        display: "flex",
        alignItems: "center",
        height: "36px",
        boxSizing: "border-box",
    },
    [theme.breakpoints.down("sm")]: {
        width: "100%",
        minWidth: "unset",
    },
}));

